import { REQUIRED } from '../../carwiz-form/CarwizForm/constants';

export default {
  required: (value) => (value ? undefined : REQUIRED)
};
